import { render, staticRenderFns } from "./cartridge-skin.vue?vue&type=template&id=1cf1399b"
import script from "./cartridge-skin.vue?vue&type=script&lang=js"
export * from "./cartridge-skin.vue?vue&type=script&lang=js"
import style0 from "./cartridge-skin.vue?vue&type=style&index=0&id=1cf1399b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports